(function() {
  var ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.WeightSetDialog = (function(superClass) {
    var BACKSPACE, DELETE, DOWN, ENTER, LEFT, NUMBERS, NUMERIC, NUMPAD, RIGHT, TAB, UP;

    extend(WeightSetDialog, superClass);

    function WeightSetDialog() {
      return WeightSetDialog.__super__.constructor.apply(this, arguments);
    }

    BACKSPACE = 8;

    TAB = 9;

    ENTER = 13;

    LEFT = 37;

    UP = 38;

    RIGHT = 39;

    DOWN = 40;

    DELETE = 46;

    NUMBERS = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

    NUMPAD = [96, 97, 98, 99, 100, 101, 102, 103, 104, 105];

    NUMERIC = NUMBERS.concat(NUMPAD);

    WeightSetDialog.prototype.init = function() {
      this.layoutUrl = 'backend/portal/weightings/weight-set/load-layout';
      this.saveUrl = 'backend/portal/weightings/weight-set/save';
      this.createDialog();
      this.openDialog();
      this.displayLoadingMessage();
      return this.validator = new ValidationEngine();
    };

    WeightSetDialog.prototype.getPostData = function() {
      var aid, data, elem, hid, i, len, ref;
      data = {
        'ws_id': $('input[name="ws_id"]').val(),
        'weights': {}
      };
      ref = this.dialog.find('form input[name="weight"]');
      for (i = 0, len = ref.length; i < len; i++) {
        elem = ref[i];
        elem = $(elem);
        hid = elem.attr('data-hybrid-id');
        aid = elem.attr('data-aspect-id');
        if (!data.weights[hid]) {
          data.weights[hid] = {};
        }
        data.weights[hid][aid] = elem.val();
      }
      return JSON.stringify(data);
    };

    WeightSetDialog.prototype.afterLoadLayout = function(selector, response) {
      var ref, self;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      self = this;
      this.dialog.find('.weightset-mask').mask('?99', {
        placeholder: ''
      });
      this.dialog.find('.ws-scroll').on('scroll', function() {
        self.dialog.find('#ws-aspects-container')[0].scrollLeft = this.scrollLeft;
        return self.dialog.find('#ws-hybrids-container')[0].scrollTop = this.scrollTop;
      });
      this.dialog.find('.speedbox-aspect').on('keyup', function(e) {
        var aspect, ref1;
        if ((ref1 = e.keyCode, indexOf.call(NUMERIC, ref1) >= 0) || e.keyCode === BACKSPACE || e.keyCode === DELETE) {
          aspect = $(this).attr('name');
          return self.dialog.find('input[name="weight"][data-aspect-id="' + aspect + '"]').val($(this).val()).trigger('change');
        } else if (e.keyCode === LEFT) {
          return $(this).closest('th').prev().find('.speedbox-aspect').focus();
        } else if (e.keyCode === RIGHT) {
          return $(this).closest('th').next().find('.speedbox-aspect').focus();
        }
      });
      this.dialog.find('.speedbox-hybrid').on('keyup', function(e) {
        var hybrid, ref1;
        if ((ref1 = e.keyCode, indexOf.call(NUMERIC, ref1) >= 0) || e.keyCode === BACKSPACE || e.keyCode === DELETE) {
          hybrid = $(this).attr('name');
          return self.dialog.find('input[name="weight"][data-hybrid-id="' + hybrid + '"]').val($(this).val()).trigger('change');
        } else if (e.keyCode === UP || (e.keyCode === ENTER && e.shiftKey)) {
          return $(this).closest('tr').prev().find('.speedbox-hybrid').focus();
        } else if (e.keyCode === DOWN || (e.keyCode === ENTER && !e.shiftKey)) {
          return $(this).closest('tr').next().find('.speedbox-hybrid').focus();
        }
      });
      this.dialog.find('input[name="weight"]').on('keyup', function(e) {
        var aspect;
        if (e.keyCode === LEFT) {
          return $(this).closest('td').prev().find('input[name="weight"]').focus();
        } else if (e.keyCode === UP || (e.keyCode === ENTER && e.shiftKey)) {
          aspect = $(this).data('aspect-id');
          return $(this).closest('tr').prev().find("input[name='weight'][data-aspect-id='" + aspect + "']").focus();
        } else if (e.keyCode === RIGHT) {
          return $(this).closest('td').next().find('input[name="weight"]').focus();
        } else if (e.keyCode === DOWN || (e.keyCode === ENTER && !e.shiftKey)) {
          aspect = $(this).data('aspect-id');
          return $(this).closest('tr').next().find("input[name='weight'][data-aspect-id='" + aspect + "']").focus();
        }
      });
      this.dialog.find('input[name="weight"]').on('change', function(e) {
        return $(this).addClass('validate-between1and10');
      });
      this.dialog.find('.speedbox').on('blur', function() {
        return $(this).val('');
      });
      this.dialog.find('.excel-btn').on('click', function() {
        var url;
        url = 'backend/portal/weightings/weight-set/excel-export?weight_set_id=' + $('input[name="ws_id"]').val();
        return window.open(url, '_blank');
      });
      this.dialog.find('.cancel-btn').removeAttr('data-dismiss').on('click', (function(_this) {
        return function() {
          return _this.refresh();
        };
      })(this));
      this.validator.makeFormValidator('weight_set', '#table-ws', this.dialog.find('.errorDiv'), (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.save('Saving Weightings...');
          }
        };
      })(this));
      this.validator.registerRule({
        'selector': '.validate-between1and10',
        'text': 'Weight must be an integer between 1 and 10',
        'func': function(elem) {
          var val;
          val = parseFloat($(elem).val());
          return val % 1 === 0 && val >= 1 && val <= 10;
        }
      });
      this.validator.stopValidating();
      $('.save-btn').bind('click', (function(_this) {
        return function() {
          _this.validator.startValidating();
          return _this.validator.validateAll();
        };
      })(this));
      $(window).unbind('modal_resized').bind('modal_resized', debounce((function(_this) {
        return function(e) {
          return _this.resize();
        };
      })(this)));
      return this.resize();
    };

    WeightSetDialog.prototype.getRemainingHeight = function(element) {
      var extraHeight, parentHeight, sibheight, siblings;
      parentHeight = element.parent().height();
      siblings = element.siblings();
      sibheight = 0;
      siblings.each(function() {
        return sibheight += $(this).outerHeight(true);
      });
      extraHeight = element.outerHeight(true) - element.height();
      return parentHeight - sibheight - extraHeight;
    };

    WeightSetDialog.prototype.resize = function() {
      var element, size, ths;
      ths = this;
      element = ths.dialog.find('.modal-body');
      size = ths.getRemainingHeight(element);
      element.css({
        height: size + 'px'
      });
      return element = ths.dialog.find('ws-scrollarea');
    };

    return WeightSetDialog;

  })(FullPageHandler);

}).call(this);
